import session from '@updater-core/interactors/shell/session';
import { createGateway } from './gateway';
import { createInteractor } from './interactor';

const gateway = createGateway();
export default createInteractor({ gateway, session });
